var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1243,
    height: 1011,
    viewBox: "0 0 1243 1011",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.629 257.11L463.672 296.292L303.297 203.239L373.694 164.067L531.629 257.11Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.629 464.023L463.672 503.195L303.297 410.153L373.694 370.97L531.629 464.023Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.242 464.023L463.285 503.195L302.91 410.153L373.308 370.97L531.242 464.023Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.668 296.293V503.195",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.306 164.067V370.969L303.363 410.084V203.171",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.629 256.429V463.342",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.711 373.42L251.754 412.603L91.3672 319.549L161.765 280.378L319.711 373.42Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.711 580.323L251.754 619.505L91.3672 526.463L161.765 487.28L319.711 580.323Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.312 580.323L251.367 619.505L90.9805 526.463L161.378 487.28L319.312 580.323Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.754 412.604V619.505",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.376 280.378V487.28L91.4336 526.394V319.481",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.711 372.739V579.652",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.867 360.559L896.921 399.742L736.535 306.699L806.933 267.517L964.867 360.559Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.867 567.472L896.921 606.655L736.535 513.601L806.933 474.43L964.867 567.472Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.48 567.472L896.535 606.655L736.148 513.601L806.546 474.43L964.48 567.472Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.922 399.742V606.655",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.544 267.517V474.43L736.602 513.533V306.631",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.867 359.889V566.79",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1175.42 477.301L1107.46 516.484L947.09 423.43L1017.49 384.259L1175.42 477.301Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.42 684.215L1107.46 723.386L947.09 630.344L1017.49 591.161L1175.42 684.215Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.03 684.215L1107.08 723.386L946.691 630.344L1017.09 591.161L1175.03 684.215Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.46 516.484V723.386",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.09 384.259V591.161L947.156 630.275V423.362",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.42 476.62V683.533",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.875 220.626L654.821 259.809L815.207 166.755L744.81 127.584L586.875 220.626Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.875 427.54L654.821 466.711L815.207 373.669L744.81 334.486L586.875 427.54Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.262 427.54L655.207 466.711L815.594 373.669L745.196 334.486L587.262 427.54Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.82 259.81V466.711",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.199 127.584V334.486L815.142 373.6V166.687",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.875 219.945V426.858",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.34 127.403L505.286 166.575L665.672 73.5325L595.274 34.3496L437.34 127.403Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.34 334.305L505.286 373.488L665.672 280.446L595.274 241.263L437.34 334.305Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.727 334.305L505.672 373.488L666.059 280.446L595.661 241.263L437.727 334.305Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.285 166.575V373.488",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.664 34.3496V241.263L665.606 280.377V73.4643",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.34 126.722V333.635",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.082 762.933L665.039 802.104L825.425 709.062L755.028 669.891L597.082 762.933Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.082 969.835L665.039 1009.02L825.425 915.976L755.028 876.793L597.082 969.835Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.48 969.835L665.426 1009.02L825.813 915.976L755.415 876.793L597.48 969.835Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.039 802.104V1009.02",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.414 669.891V876.792L825.356 915.907V708.994",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.082 762.252V969.165",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.672 670.14L531.629 709.311L692.015 616.269L621.618 577.086L463.672 670.14Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.672 877.041L531.629 916.224L692.015 823.171L621.618 783.999L463.672 877.041Z",
    stroke: "#231F20",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.07 877.041L532.016 916.224L692.402 823.171L622.005 783.999L464.07 877.041Z",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.629 709.312V916.225",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.004 577.086V783.999L691.946 823.102V616.201",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.672 669.458V876.36",
    stroke: "white",
    strokeWidth: 3.03065,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.336 248.243L1215.12 831.218",
    stroke: "white",
    strokeWidth: 18.1953,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.05 762.421L867.112 886.928L357.406 591.217L581.13 466.711L1083.05 762.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.582 716.972L374.306 592.466",
    stroke: "white",
    strokeWidth: 18.1953,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.628 548.902C515.45 548.005 513.078 547.324 510.467 546.586C515.359 538.607 520.115 530.877 525.053 522.818C522.533 522.182 520.445 521.66 518.004 521.047C522.578 512.534 527.062 504.203 531.739 495.497C528.889 495.077 526.54 494.736 523.35 494.259C533.487 479.946 539.378 463.941 545.484 447.074C551.852 463.748 557.403 479.901 567.834 494.248C564.644 494.702 562.215 495.043 559.309 495.463C563.975 504.1 568.447 512.364 573.112 521.002C570.808 521.581 568.742 522.103 565.995 522.795C570.921 530.798 575.711 538.584 580.638 546.598C577.947 547.347 575.564 548.005 572.454 548.868C578.685 557.756 584.678 566.28 591.239 575.633H551.988V606.507H539.207V575.849H499.695C506.313 566.416 512.306 557.869 518.628 548.868V548.902Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 7.58231,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.467 626.791C780.322 626.178 778.71 625.724 776.951 625.225C780.265 619.833 783.466 614.601 786.815 609.164C785.112 608.732 783.693 608.38 782.047 607.972C785.135 602.217 788.165 596.587 791.332 590.696C789.403 590.412 787.814 590.174 785.657 589.867C792.513 580.185 796.486 569.368 800.617 557.972C804.919 569.243 808.676 580.162 815.725 589.867C813.568 590.174 811.923 590.412 809.959 590.685C813.114 596.519 816.134 602.115 819.289 607.949C817.734 608.346 816.338 608.698 814.477 609.164C817.802 614.578 821.049 619.833 824.374 625.259C822.558 625.77 820.946 626.213 818.835 626.791C823.046 632.796 827.099 638.562 831.537 644.885H804.999V665.759H796.361V645.032H769.652C774.125 638.653 778.177 632.875 782.456 626.791H782.467Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 7.58231,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M888.124 777.189C885.978 776.576 884.366 776.122 882.607 775.622C885.922 770.231 889.122 764.998 892.471 759.561C890.768 759.13 889.349 758.778 887.704 758.369C890.791 752.614 893.822 746.984 896.989 741.093C895.059 740.81 893.47 740.571 891.313 740.265C898.169 730.583 902.142 719.765 906.274 708.369C910.575 719.64 914.333 730.56 921.381 740.265C919.225 740.571 917.579 740.81 915.615 741.082C918.771 746.916 921.79 752.512 924.945 758.347C923.39 758.744 921.994 759.096 920.133 759.561C923.459 764.975 926.705 770.231 930.031 775.656C928.215 776.167 926.603 776.61 924.491 777.189C928.703 783.193 932.755 788.96 937.193 795.282H910.655V816.156H902.017V795.43H875.309C879.781 789.05 883.833 783.273 888.112 777.189H888.124Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 7.58231,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.684 567.915C469.063 566.894 466.362 566.122 463.399 565.282C468.972 556.201 474.375 547.393 480.005 538.222C477.134 537.495 474.761 536.905 471.98 536.201C477.19 526.519 482.287 517.018 487.622 507.109C484.375 506.632 481.697 506.235 478.064 505.702C489.608 489.402 496.305 471.184 503.263 451.979C510.516 470.957 516.827 489.357 528.711 505.69C525.079 506.212 522.31 506.598 518.995 507.075C524.307 516.905 529.404 526.326 534.716 536.156C532.094 536.814 529.733 537.416 526.623 538.199C532.23 547.314 537.69 556.179 543.297 565.305C540.232 566.156 537.52 566.905 533.978 567.893C541.072 578.006 547.894 587.722 555.363 598.369H510.675V633.523H496.123V598.619H451.129C458.666 587.881 465.488 578.154 472.684 567.893V567.915Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 7.58231,
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.934 578.971C714.313 577.949 711.612 577.178 708.649 576.338C714.222 567.257 719.625 558.449 725.255 549.277C722.384 548.551 720.011 547.961 717.23 547.257C722.44 537.575 727.537 528.074 732.872 518.165C729.625 517.688 726.947 517.291 723.314 516.757C734.858 500.458 741.555 482.24 748.513 463.034C755.766 482.013 762.077 500.412 773.961 516.746C770.329 517.268 767.56 517.654 764.245 518.131C769.557 527.961 774.654 537.382 779.966 547.211C777.344 547.87 774.983 548.471 771.873 549.255C777.48 558.369 782.94 567.234 788.547 576.36C785.482 577.212 782.77 577.961 779.228 578.948C786.322 589.062 793.144 598.778 800.613 609.425H755.925V644.578H741.373V609.675H696.379C703.916 598.937 710.738 589.209 717.934 578.948V578.971Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 7.58231,
    strokeMiterlimit: 10
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M831.508 809.143C827.887 808.121 825.186 807.349 822.223 806.509C827.797 797.429 833.199 788.621 838.829 779.449C835.958 778.723 833.585 778.132 830.804 777.429C836.014 767.746 841.111 758.246 846.446 748.337C843.2 747.86 840.521 747.463 836.889 746.929C848.432 730.629 855.129 712.412 862.087 693.206C869.34 712.185 875.651 730.584 887.536 746.918C883.903 747.44 881.134 747.826 877.819 748.303C883.132 758.132 888.228 767.554 893.54 777.383C890.918 778.042 888.557 778.643 885.447 779.426C891.054 788.541 896.514 797.406 902.121 806.532C899.057 807.383 896.344 808.133 892.802 809.12C899.897 819.234 906.718 828.95 914.187 839.597H869.499V874.75H854.948V839.847H809.953C817.49 829.109 824.312 819.381 831.508 809.12V809.143Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 7.58231,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M649.302 174.328L375.999 8.91309L14 233.59L409.949 464.635",
    stroke: "white",
    strokeWidth: 13.6436,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M885.705 317.404L1228 524.567L861.823 706.974L841.914 717.61L640.074 599.834",
    stroke: "white",
    strokeWidth: 13.6436,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M871.035 271.887L889.287 299.152V355.406L871.035 364.339L804.746 326.064V250.65V233.612L871.035 271.887Z",
    stroke: "white",
    strokeWidth: 12.134,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M763.383 226.768L804.745 250.65",
    stroke: "white",
    strokeWidth: 12.134,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M763.383 285.757L804.745 309.639",
    stroke: "white",
    strokeWidth: 12.134,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.561 527.041C517.596 522.115 499.037 472.319 495.394 464.033C479.355 427.483 442.93 407.12 405.541 398.494C388.299 394.521 370.569 394.873 353.395 398.868C350.047 399.64 321.602 405.633 322.703 410.378C334.008 458.948 354.735 511.082 406.755 528.369C428.469 535.588 452.476 537.801 475.042 533.738C484.667 532.001 499.979 531.683 508.549 527.041H508.561Z",
    stroke: "white",
    strokeWidth: 12.134,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.210579c988a4360293aacb0b7cf8b665.svg";
export { ForwardRef as ReactComponent };